import withErrorCheck from "../CheckError";
import server from "../Server";

export type GetPlayersGroupsExperiencePayload = { pid: number };
export type PlayerGroupExperience = {
  player_id: number;
  group_id: number;
  group_name: string;
  points_earned: number;
  group_logo: string | null;
};

export const GetPlayersGroupsExperience = async (
  { pid }: GetPlayersGroupsExperiencePayload
): Promise<PlayerGroupExperience[]> => {
  const response = await server
    .from("players_group_experience_points")
    .select(["player_id","group_id","group_name","points_earned","group_logo"].join(","))
    .eq("player_id", pid)
    .order("points_earned", { ascending: false });

  const rows = (withErrorCheck(response as any) || []) as PlayerGroupExperience[];
  return rows;
};
